export default __webpack_public_path__ + "assets/d20b3cf656a22297df73e03218b85448.png";